import { FetchHttpRequest } from './core/FetchHttpRequest';
import { BookingsService } from './services/BookingsService';
import { DestinationsService } from './services/DestinationsService';
import { FlightUpgradeService } from './services/FlightUpgradeService';
import { PlannerService } from './services/PlannerService';
import { PreferencesService } from './services/PreferencesService';
import { SearchService } from './services/SearchService';
import { VisaAndHealthService } from './services/VisaAndHealthService';
var OptiClient = /** @class */ (function () {
    function OptiClient(config, HttpRequest) {
        if (HttpRequest === void 0) { HttpRequest = FetchHttpRequest; }
        var _a, _b, _c, _d;
        this.request = new HttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : 'https://dev.kenya-airways.com/en',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '1.0.0',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
        });
        this.bookings = new BookingsService(this.request);
        this.destinations = new DestinationsService(this.request);
        this.flightUpgrade = new FlightUpgradeService(this.request);
        this.planner = new PlannerService(this.request);
        this.preferences = new PreferencesService(this.request);
        this.search = new SearchService(this.request);
        this.visaAndHealth = new VisaAndHealthService(this.request);
    }
    return OptiClient;
}());
export { OptiClient };
